<template>
  <div class="thank-you">
    <div class="container">
      <img v-if="title" src="@/assets/img/icons/check-circle.svg" alt="Check" class="icon"/>
      <h3 v-if="title" class="title">{{ $t(title) }}</h3>
      <p v-if="message" class="message">{{ $t(message) }}</p>
      <router-link to="/" class="btn">{{ $t("thankYou.backToHome") }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "message"]
}
</script>

<style lang="scss" scoped>
.thank-you {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 3rem;

    .icon {
      width: 60px;
      height: 60px;
      margin-bottom: 15px;
    }

    .title {
      color: var(--gray-80);
      font-size: var(--text-30) !important;
      font-weight: var(--text-medium);
      margin-bottom: 15px;
      font-family: "Open Sans", sans-serif !important;
    }

    .btn {
      border: 1px solid #aaa;
      border-radius: 5px;
      padding: 5px 10px;
      color: var(--gray-80);
      font-weight: var(--text-medium);
      margin-top: 20px;
      text-transform: uppercase;

      &:hover {
        border-color: var(--blue-50);
        color: var(--blue-50)
      }
    }
  }
}
</style>
